import isEmpty from "../lib/isEmpty";

export const socialNetwork = (req) => {
  let errors = {};
  // if (isEmpty(req.facebookUrl)) {
  //   errors.facebookUrl = "facebook is required";
  // }
  // if (isEmpty(req.twitterUrl)) {
  //   errors.twitterUrl = "twitter is required";
  // }
  // if (isEmpty(req.linkedinUrl)) {
  //   errors.linkedinUrl = "linkedin is required";
  // }
  // if (isEmpty(req.instagramUrl)) {
  //   errors.instagramUrl = "instagram is required";
  // }
  // if (!isEmpty(errors)) {
  //   return {
  //     status: false,
  //     errors,
  //   };
  // }

  return { status: true };
};

export const contactInfoAuth = (req) => {
  let errors = {};
  if (isEmpty(req.country)) {
    errors.country = "Country is required";
  }
  if (isEmpty(req.state)) {
    errors.state = "State is required";
  }
  if (isEmpty(req.city)) {
    errors.city = "City is required";
  }
  if (isEmpty(req.address)) {
    errors.address = "Address is required";
  }
  if (isEmpty(req.website)) {
    errors.website = "Website is required";
  }
  if (isEmpty(req.phoneNo)) {
    errors.phoneNo = "Phone Number is required";
  }
  if (!isEmpty(errors)) {
    return {
      status: false,
      errors,
    };
  }

  return { status: true };
};
export const schoolProfile = (req) => {
  let errors = {};
  if (isEmpty(req.companyName)) {
    errors.companyName = "CompanyName is required";
  }
  if (isEmpty(req.since)) {
    errors.since = "Since is required";
  }
  if (isEmpty(req.teamSize)) {
    errors.teamSize = "TeamSize is required";
  }
  if (isEmpty(req.type)) {
    errors.type = "Type is required";
  }
  if (isEmpty(req.jobTitle)) {
    errors.jobTitle = "Job title is required";
  }
  // if (isEmpty(req.country)) {
  //   errors.country = "country is required";
  // }
  if (isEmpty(req.typesOfService)) {
    errors.typesOfService = "Types of service is required";
  }
  // if (isEmpty(req.manPowerRequirement)) {
  //   errors.manPowerRequirement = "man power requirement is required";
  // }
  // if (isEmpty(req.classes)) {
  //   errors.classes = "classes is required";
  // }
  // if (isEmpty(req.studentStrength)) {
  //   errors.studentStrength = "studentStrength is required";
  // }
  if (isEmpty(req.description)) {
    errors.description = "Description is required";
  }
  if (!isEmpty(errors)) {
    return {
      status: false,
      errors,
    };
  }

  return { status: true };
};
